import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { UserService } from 'app/_services/user.service';

import { Peca } from '../../_models/peca';
import { Resposta } from '../../_models/resposta';

@Component({
    selector: 'app-lista-respostas', templateUrl: './lista-respostas.component.html', styleUrls: ['./lista-respostas.component.scss'],
    standalone: false
})
export class BuyerCondicoesListaRespostasComponent implements OnInit {
    @Output() selecionarPeca = new EventEmitter();
    @Input() respostas: Resposta[];

    constructor(public userService: UserService) { }

    ngOnInit(): void { }

    selecionar(peca: Peca) {
        this.selecionarPeca.emit({ item_id: peca.itemId });
    }
}
